export default __webpack_public_path__ + "static/media/6B3A3044-0071-49D6-BC82-A4A263D74240_1_105_c.7532c8eb.jpeg";